<template>
  <div id="NotFound">
    <div id="error404">
      <img src="../assets/error_404.png"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  data () {
    return {

    }
  }
}
</script>

<style scoped>
#error404 img {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFoundPage.vue